export default __webpack_public_path__ + "static/media/git_original_wordmark_logo_icon_146510.f43e2ebc.png";